import React from 'react'
import {FaPhone} from 'react-icons/fa'
import {StyledAnnouncement} from './StyledComponents';

const Announcement = () => {
    return (
        <StyledAnnouncement>
           25350 Magic Mountain PKWY, Suite 300, Valencia, CA 91355 <a href="tel:8183782485"> <FaPhone /> (818) 378-2485</a>           
        </StyledAnnouncement>
    )
}

export default Announcement